import React, { useEffect } from 'react';
import { UserSection } from './UserSection/UserSection';
import { EmailAddressSectionProps } from './EmailAddressSection/EmailAddressSection';
import {
  OrganizationsSection,
  Membership,
} from './OrganizationsSection/OrganizationsSection';
import { Emails } from './Emails/Emails';
import { makePrimary, removeEmail, resendVerification } from './requests';
import { PageContainer, PrimaryNavigation } from 'components/shared';
import PageHeader from 'components/PageHeader/PageHeader';
import PageSubHeader, {
  SubHeaderLink,
} from 'components/PageHeader/PageSubHeader';
import { Reviewer } from 'components/shared/PrimaryNavigation/PrimaryNavigation';
import { Stack } from 'components/layout';
import { createToast, Toast } from 'components/core';
import { ProfilePageEmailVerificationFlash } from 'components/shared/FlashMessage';

export type ProfilePageProps = {
  navigationLinks: SubHeaderLink[];
  reviewer: Reviewer;
  emails: EmailAddressSectionProps['emails'];
  toastMessage: string | null;
  memberships?: Membership[];
};

const ProfilePage = (props: ProfilePageProps) => {
  const {
    reviewer,
    navigationLinks,
    emails,
    toastMessage,
    memberships = [],
  } = props;

  const primaryEmail = emails.find((email) => email.primary);

  const primaryVerified = !!primaryEmail?.verified_at;

  useEffect(() => {
    if (toastMessage) {
      createToast(<Toast type="success">{toastMessage}</Toast>);
    }
  }, [toastMessage]);

  return (
    <>
      <PrimaryNavigation reviewer={reviewer} />
      <PageHeader headerText="Profile" />
      <PageSubHeader links={navigationLinks} />
      {!primaryVerified && (
        <ProfilePageEmailVerificationFlash useDefault={true} />
      )}
      <PageContainer isMain={true}>
        <Stack spacing={10}>
          <UserSection reviewer={reviewer} />
          <Emails
            emails={emails}
            removeEmail={removeEmail}
            makePrimary={makePrimary}
            resendVerification={resendVerification}
          />
          <OrganizationsSection memberships={memberships} />
        </Stack>
      </PageContainer>
    </>
  );
};

export { ProfilePage };
